import React from "react";

export function renderRich(text) {
  if (text == null) return null;
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, index) => {
    const match = /^\*\*([^*]+)\*\*$/.exec(part);
    if (match) {
      return <strong key={index}>{match[1]}</strong>;
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}

export default renderRich;
